<template>
<div>
<header class="centerH2">
    <a @click="()=>$router.push({name:'Center'})" class="btn-back">
        <img src="@/assets/img/i-left-grey.png" alt="">
    </a>
    账号绑定
</header>
    <div class="main accountM">
    <ul>
        <li>
            <a @click="()=> $router.push({name:'BindId'})">
                <div class="llabel">
                    身份证绑定
                </div>
                <div class="rdiv">
                    <img src="@/assets/img/ic_common_next_normal.png" alt="">
                </div>
            </a>
        </li>
        <li>
            <a @click="onFace">
                <div class="llabel">
                    人脸识别认证
                </div>
                <div class="rdiv">
                    <img src="@/assets/img/ic_common_next_normal.png" alt="">
                </div>
            </a>
        </li>
        <li>
            <a @click="()=> $router.push({name:'BindCard'})">
                <div class="llabel">
                    读者账号绑定
                </div>
                <div class="rdiv">
                    <img src="@/assets/img/ic_common_next_normal.png" alt="">
                </div>
            </a>
        </li>
    </ul>

</div>
</div>
</template>
<script>
import { USER,ACCESS_TOKEN } from "@/store/mutation-types";
export default {
    methods:{
        onFace(){
            const token =  this.$ls.get(ACCESS_TOKEN);
            this.user = this.$ls.get(USER);
            const customerId =  this.$route.query.customerId || this.$ls.get("CUSTOMER") 
            this.$router.push ({name:'Face', query: { 'id': encodeURIComponent(JSON.stringify(this.user)),'token':token,'customerId':customerId}})
        }
    },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
  },
};
</script>
<style scoped>
@import "~@/assets/css/center.css";
</style>
